var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2 12c0-5.52 4.48-10 10-10s10 4.48 10 10-4.48 10-10 10-10-4.48-10-10zm11 4v2h-2v-2h2zm-1 4c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-4-10c0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.2829-0.79 1.9733-1.5592 2.6455-0.7298 0.6378-1.4408 1.2591-1.4408 2.3545h-2c0-1.8213 0.9421-2.5434 1.7704-3.1783 0.6498-0.4981 1.2296-0.9425 1.2296-1.8217 0-1.1-0.9-2-2-2s-2 0.9-2 2h-2z",
    clipRule: "evenodd",
    fill: "#A9B0B3",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m2 12c0-5.52 4.48-10 10-10s10 4.48 10 10-4.48 10-10 10-10-4.48-10-10zm11 4v2h-2v-2h2zm-1 4c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-4-10c0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.2829-0.79 1.9733-1.5592 2.6455-0.7298 0.6378-1.4408 1.2591-1.4408 2.3545h-2c0-1.8213 0.9421-2.5434 1.7704-3.1783 0.6498-0.4981 1.2296-0.9425 1.2296-1.8217 0-1.1-0.9-2-2-2s-2 0.9-2 2h-2z",
    clipRule: "evenodd",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.a7de7c971dcae5798e70c236a7379326.svg";
export { ForwardRef as ReactComponent };